import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/home/index.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/', // 首页
    name: 'Home',
    component: Home,
  },
  {
    path: '/apply', // 申请入驻
    name: 'apply',
    meta: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/apply/index.vue'),
  },
  {
    path: '/ideas/videos', // 视频列表
    name: 'videos',
    component: () => import('@/views/ideas/videos.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/helpCenter', // 帮助中心
    name: 'helpCenter',
    component: () => import('@/views/helpCenter/index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/quesDetail', // 问题详情
    name: 'quesDetail',
    component: () => import('@/views/helpCenter/quesDetail.vue'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/ideas/broadcasts',
    component: () => import('@/views/ideas/broadcasts/dash.vue'),
    children: [
      {
        path: '/', // 播单管理
        component: () => import('@/views/ideas/broadcasts/index.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'select', //播单选选择器
        name: 'broadcastsSelect',
        component: () => import('@/views/ideas/broadcasts/select.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: 'create', // 创建播单
        name: 'broadcastsCreate',
        component: () => import('@/views/ideas/broadcasts/create.vue'),
        meta: {
          auth: true,
        },
      },
      {
        path: ':id', // 播单详情
        name: 'broadcastsDetail',
        component: () => import('@/views/ideas/broadcasts/detail.vue'),
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '/up',
    name: 'up',
    component: () => import('@/views/up/index.vue'),
    children: [
      {
        path: 'video',
        component: () => import('@/views/up/video.vue'),
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/notFound/index.vue'),
  },
]
console.log('process.env.BASE_URL', process.env.BASE_URL)
const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes,
})

export default router
